import { all, takeEvery, fork, put, select, call } from 'redux-saga/effects'
import actions from './actions'
import {
    getListTask,
    updateTaskStatusAPI,
    createNewTask,
    getTaskByIdAPI,
} from '../../services/apis/TaskApiServices'

// storage
import { setLocalData, getLocalData } from '../../services/StorageServices'
import { notification } from 'antd'

function* saga_getListTask(action) {
    try {
        const { page_number, page_size, deleted } = action.payload

        const resquest = yield call(
            getListTask,
            page_number,
            page_size,
            deleted
        )
        if (resquest.error.code === 200) {
            yield put(actions.action.getListTaskDone(resquest.data))
        }
    } catch (ex) {
        console.log('getListEvent Error : ', ex.message)
    }
}
function* saga_updateTaskStatus(action) {
    try {
        const { task_id, status } = action.payload

        const resquest = yield call(updateTaskStatusAPI, task_id, status)
        if (resquest.error.code === 200) {
            console.log('update trang thai nhiem vu thanh cong')
            yield put(actions.action.getListTask(1, 20, -1))
        }
    } catch (ex) {
        console.log('getListEvent Error : ', ex.message)
    }
}
function* saga_createNewTask(action) {
    try {
        const { body } = action.payload

        const resquest = yield call(createNewTask, body)
        if (resquest.error.code === 200) {
            yield put(actions.action.getListTask(1, 20, -1))
            notification.success({
                message: 'Thêm mới nhiệm vụ thành công',
            })
        }
    } catch (ex) {
        console.log('getListEvent Error : ', ex.message)
    }
}
function* saga_getCurrentTask(action) {
    try {
        const { id } = action.payload

        const resquest = yield call(getTaskByIdAPI, id)
        if (resquest.error.code === 200) {
            yield put(actions.action.getCurrentTaskDone(resquest.data))
        }
    } catch (ex) {
        console.log('get task by id Error : ', ex.message)
    }
}
function* listen() {
    yield takeEvery(actions.type.GET_LIST_TASK, saga_getListTask)
    yield takeEvery(actions.type.UPDATE_TASK_STATUS, saga_updateTaskStatus)
    yield takeEvery(actions.type.CREATE_NEW_TASK, saga_createNewTask)
    yield takeEvery(actions.type.GET_CURRENT_TASK, saga_getCurrentTask)
}

export default function* taskSaga() {
    yield all([fork(listen)])
}
